import fetcher from 'src/api/RequestHandler';
import { ROUTES } from 'src/api/Routes';

// Mirrors WHATSAPP_STATE on the server; GET /users/whatsapp/state switches on it.
export enum WhatsAppStatus {
  DISCONNECTED = 'DISCONNECTED',
  PENDING = 'PENDING',
  CONNECTED = 'CONNECTED',
}

export type WhatsAppStateResponse = {
  status: WhatsAppStatus;
  qr?: string;
  phone?: string;
};

const disconnected: WhatsAppStateResponse = {
  status: WhatsAppStatus.DISCONNECTED,
};

export function getWhatsAppState(): Promise<WhatsAppStateResponse> {
  return fetcher()
    .get(ROUTES.GET.GET_WHATSAPP_STATE)
    .then(({ data }) => data)
    .catch(() => disconnected);
}

export function startWhatsAppAuth(): Promise<WhatsAppStateResponse> {
  return fetcher()
    .get(ROUTES.GET.GET_WHATSAPP_AUTH)
    .then(({ data }) => data);
}

export function logoutWhatsApp(): Promise<WhatsAppStateResponse> {
  return fetcher()
    .post(ROUTES.POST.WHATSAPP_LOGOUT)
    .then(({ data }) => data);
}
